
<div id="full-width2"class="dialog widget widget-content corner-all front dialog-buttons draggable"
style=" width: 640px; top: 196px; left: 155px; display: block;">

    <div class="dialog-titlebar widget-header corner-all" id="exampleModalLongTitle" >
      <i class="fa fa-times fa-lg mng-qualifier-close-btn close2" (click)="activeModal.close('close')" title="close"></i>
      </div>

    <div style="width: auto; min-height: 23px; max-height: none; height: auto;" class="dialog-content widget-content">
  <div >
    <div style="margin-bottom: 15px; display: flex; align-items: center;">
            <input type="checkbox"
                   id="roadsideSession"
                   [(ngModel)]="isRoadsideSession"
                   name="isRoadsideSession"
                   style="margin-right: 10px; width: 20px; height: 20px; cursor: pointer;">
            <label for="roadsideSession" style="margin-bottom: 0; font-weight: bold; color: #000; cursor: pointer;">
                {{'Is Roadside session'|translate}}
            </label>
        </div>
    <h6 style="color:#003478">{{'Customer Concern'|translate}}</h6>
    <form >
        <textarea [(ngModel)]="text"  name="text"
        placeholder="{{'Customer description of their concern'|translate}}."
        rows="4" cols="30" style="width: 600px;" maxlength="256"></textarea>
    </form>
  </div>
  </div>
  <div class="dialog-buttonpane widget-content ">
    <div style="text-align: right" >
      <button type="button" class="btn btn-primary shadow-none" style="display: inline-block" (click)="captureSymptoms();">
        <span >{{'CAPTURE SYMPTOMS'|translate}}</span>
      </button>
      <button type="button" class="btn btn-primary shadow-none" style="display: inline-block"  >
        <span (click)="activeModal.close('close')">{{'CLOSE'|translate}}</span>
      </button>
    </div>
  </div>
</div>
<div id="overlay" *ngIf="saveInProgress">
  <span id="nav-spinner">
    <img src="assets/images/ajax-loader.gif" width="80" height="80">
  </span>
</div>
<ng-template #importDTCConfirmPopup let-modal>
  <div class="container NWTContainer">
      <div class="row popup-header">
          <div class="pull-left">{{'Information'|translate}}</div>
          <div class="pull-right cross-button" style="margin-top: -5.6%;" title="close"><i class="fa fa-times" aria-hidden="true"
                  (click)="modal.dismiss('importDTCConfirmPopup')"></i></div>
      </div>
      <div>
          <label class='msg-body'><span>
            {{'DTC_View_Confirm_Msg'|translate}}<br/>
            <span>({{'DTC_View_Confirm_Msg1'|translate}})</span>
          </span>
          </label>
      </div>
      <hr class="hr-line">
      <div class="popup-footer">
        <button type="button" class="close-btn-popup pull-right" name="cancel"
        (click)="modal.dismiss('importDTCConfirmPopup');dismissDTCConfirmPopup()">{{'NO'|translate}}</button>
    <button type="button" class="close-btn-popup pull-right" name="cancel"
        (click)="modal.dismiss('importDTCConfirmPopup');navigateDTCView()">{{'YES'|translate}}</button>
      </div>
  </div>
</ng-template>
